(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.scrollFrame = null;

      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      this.reveal();
      this.onScroll();

      this.onScrollHandler = () => {
        if (this.scrollFrame) return;

        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.onScroll();
        });
      };
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.cancelAnimationFrame(this.scrollFrame);
      this.headerResizeObserver?.disconnect();
    }

    onScroll() {
      if (window.tsOverlayViewport?.isScrollLocked()) return;
      const scrollTop = Math.max(window.scrollY || document.documentElement.scrollTop || 0, 0);
      this.header.classList.toggle('scrolled-past-header', scrollTop > 12);
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('animate', 'ts-header-is-hiding', 'shopify-section-header-hidden');
    }

  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const clearOldGenderState = () => {
      try {
        window.sessionStorage.removeItem('ts_gender');
      } catch (error) {
      }

      document.documentElement.removeAttribute('data-ts-gender-filter');
      document.querySelectorAll('.ts-gender-filter-hidden').forEach((element) => {
        element.classList.remove('ts-gender-filter-hidden');
        element.removeAttribute('aria-hidden');
      });

      const params = new URLSearchParams(window.location.search);
      if (!params.has('ts_gender')) return;

      const url = new URL(window.location.href);
      url.searchParams.delete('ts_gender');
      window.history.replaceState(window.history.state, '', url);
    };

    const closeDrawer = (target) => {
      const drawer = target.closest('header-drawer');
      const summary = drawer?.querySelector('#Details-menu-drawer-container > summary');
      if (summary && drawer.querySelector('#Details-menu-drawer-container')?.hasAttribute('open')) {
        drawer.closeMenuDrawer({ type: 'close' }, summary);
      }
    };

    const syncDrawerOpenState = () => {
      const details = document.querySelector('#Details-menu-drawer-container');
      const isVisiblyOpen = !!(
        details?.hasAttribute('open') &&
        (details.classList.contains('menu-opening') || details.classList.contains('is-closing'))
      );

      document.documentElement.classList.toggle('ts-drawer-open', isVisiblyOpen);
    };

    const syncMobileSearchState = () => {
      document.querySelector('.ts-header-v2__bar')?.classList.remove('ts-mobile-search-hidden');
    };

    const stopSearchTyping = () => {
      document.querySelectorAll('.ts-search-typing').forEach((trigger) => {
        trigger.classList.remove('ts-search-typing');
      });
    };

    const getSearchPanel = () => document.querySelector('[data-ts-search-panel]');
    let searchAnimation = null;
    const isSearchOpen = () => getSearchPanel()?.dataset.state === 'open';

    const animateSearchPanel = (panel, opening) => {
      const wasHidden = panel.hidden;
      const style = wasHidden ? null : window.getComputedStyle(panel);
      const from = {
        opacity: style?.opacity || '0',
        transform: style?.transform || 'translateY(-32px)',
      };
      searchAnimation?.cancel();
      panel.hidden = false;
      const finish = () => {
        if (!opening && panel.dataset.state === 'closed') panel.hidden = true;
        document.querySelector('sticky-header')?.setHeaderHeight?.();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !panel.animate) {
        searchAnimation = null;
        finish();
        return;
      }
      const animation = panel.animate([
        from,
        { opacity: opening ? 1 : 0, transform: opening ? 'translateY(0)' : 'translateY(-24px)' },
      ], {
        duration: opening ? 460 : 260,
        easing: opening ? 'cubic-bezier(0.16, 0.7, 0.3, 1)' : 'cubic-bezier(0.4, 0, 0.2, 1)',
        fill: 'both',
      });
      searchAnimation = animation;
      animation.onfinish = () => {
        if (searchAnimation !== animation) return;
        finish();
        animation.cancel();
        searchAnimation = null;
      };
    };

    const getVisibleHeaderSearchInput = () => {
      const inputs = Array.from(document.querySelectorAll('.ts-header-inline-search .search__input'));

      return inputs.find((input) => {
        const rect = input.getBoundingClientRect();
        const style = window.getComputedStyle(input);

        return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
      }) || inputs[0] || document.querySelector('.header__search .search__input');
    };

    const syncSearchModalState = () => {
      const isOpen = isSearchOpen();
      document.querySelector('[data-ts-open-search]')?.setAttribute('aria-expanded', String(isOpen));
      document.querySelector('sticky-header')?.setHeaderHeight?.();
    };

    const focusSearchInput = () => {
      syncMobileSearchState();

      const input = getVisibleHeaderSearchInput();
      if (!input) return;

      input.focus({ preventScroll: true });
      const valueLength = input.value.length;
      input.setSelectionRange(valueLength, valueLength);
    };

    const openSearchModal = () => {
      const panel = getSearchPanel();
      if (!panel) return;
      panel.dataset.state = 'open';
      panel.inert = false;
      animateSearchPanel(panel, true);
      stopSearchTyping();
      syncSearchModalState();
      document.querySelector('sticky-header')?.reveal?.();
      focusSearchInput();
    };

    const closeSearchModal = (restoreFocus = false) => {
      const panel = getSearchPanel();
      if (!panel || !isSearchOpen()) return;
      panel.dataset.state = 'closed';
      panel.querySelector('predictive-search')?.close?.();
      if (panel.contains(document.activeElement)) document.activeElement.blur();
      panel.inert = true;
      animateSearchPanel(panel, false);
      syncSearchModalState();
      if (restoreFocus) document.querySelector('[data-ts-open-search]')?.focus({ preventScroll: true });
    };

    const submitHeaderSearch = (button) => {
      const form = button.closest('form');
      const input = form?.querySelector('input[name="q"]');
      const searchTerm = input?.value?.trim() || '';

      if (!searchTerm.length) {
        input?.focus({ preventScroll: true });
        return;
      }

      const predictiveSearchClass = window.customElements?.get?.('predictive-search');
      const resolvedSearchTerm = typeof predictiveSearchClass?.resolveSearchTerm === 'function'
        ? predictiveSearchClass.resolveSearchTerm(searchTerm)
        : searchTerm;
      const searchUrl = new URL(form?.action || window.routes?.search_url || '/search', window.location.origin);

      searchUrl.searchParams.set(input.name || 'q', resolvedSearchTerm);
      form?.querySelectorAll('input[type="hidden"][name]').forEach((hiddenInput) => {
        if (hiddenInput.name !== input.name) {
          searchUrl.searchParams.set(hiddenInput.name, hiddenInput.value);
        }
      });

      window.location.assign(searchUrl.toString());
    };

    const drawerStateTarget = document.querySelector('#Details-menu-drawer-container');
    if (drawerStateTarget) {
      new MutationObserver(syncDrawerOpenState).observe(drawerStateTarget, {
        attributes: true,
        attributeFilter: ['open', 'class'],
      });
      syncDrawerOpenState();
    }

    document.addEventListener('click', (event) => {
      const headerSearchButton = event.target.closest('.ts-header-inline-search .search__button, .header__search .search__button');
      if (headerSearchButton) {
        event.preventDefault();
        submitHeaderSearch(headerSearchButton);
        return;
      }

      const searchClose = event.target.closest('[data-ts-close-search]');
      if (searchClose) {
        event.preventDefault();
        closeSearchModal(true);
        return;
      }

      const searchTrigger = event.target.closest('[data-ts-open-search]');
      if (searchTrigger) {
        event.preventDefault();
        if (!isSearchOpen()) openSearchModal();
        else closeSearchModal(true);
        return;
      }

      if (!event.target.closest('[data-ts-search-panel]')) closeSearchModal();

      const placeholderAction = event.target.closest('[data-ts-wishlist-trigger]');
      if (placeholderAction) {
        event.preventDefault();
      }

      const drawerClose = event.target.closest('[data-ts-drawer-close]');
      if (drawerClose) {
        event.preventDefault();
        closeDrawer(drawerClose);
      }

      const drawerSearch = event.target.closest('[data-ts-drawer-search]');
      if (drawerSearch) {
        event.preventDefault();
        const menu = drawerSearch.closest('.menu-drawer');
        closeDrawer(drawerSearch);
        const openAfterClose = () => {
          if (!menu.closest('details').hasAttribute('open')) openSearchModal();
        };
        const closing = drawerSearch.closest('header-drawer').drawerMotion;
        if (closing) closing.finished.then(openAfterClose, () => {});
        else openAfterClose();
      }
    });

    document.addEventListener('toggle', (event) => {
      if (event.target?.id === 'Details-menu-drawer-container') {
        window.requestAnimationFrame(() => {
          syncDrawerOpenState();
          syncMobileSearchState();
        });
      }

    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && getSearchPanel()?.hidden === false) {
        event.preventDefault();
        closeSearchModal(true);
      }
      if (event.key === ' ' && event.target.closest('[data-ts-open-search]')) {
        event.preventDefault();
        event.target.closest('[data-ts-open-search]').click();
      }
    });

    document.addEventListener('focusin', (event) => {
      if (!event.target.closest('[data-ts-search-panel], [data-ts-open-search]')) closeSearchModal();
    });

    clearOldGenderState();
    syncDrawerOpenState();
    syncSearchModalState();
    syncMobileSearchState();
    window.setTimeout(stopSearchTyping, 2800);
    document.addEventListener('DOMContentLoaded', () => {
      syncDrawerOpenState();
      syncSearchModalState();
      syncMobileSearchState();
      window.setTimeout(stopSearchTyping, 2800);
    });
    document.addEventListener('shopify:section:load', () => {
      clearOldGenderState();
      syncDrawerOpenState();
      syncSearchModalState();
      syncMobileSearchState();
      window.setTimeout(stopSearchTyping, 2800);
    });
    window.addEventListener('pageshow', () => {
      syncDrawerOpenState();
      syncSearchModalState();
      syncMobileSearchState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-brand-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ts-brand-discovery')) customElements.define('ts-brand-discovery', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.tabs = [...this.querySelectorAll('[data-brand-tab]')];
    this.panels = [...this.querySelectorAll('.ts-brand-world')];
    this.current = 0;
    this.request = 0;
    this.loads = new Map();
    this.rails = new Map();
    this.effects = new Set();
    const motion = () => matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth';
    const state = detail => this.dispatchEvent(new CustomEvent('ts:story-state',{detail}));
    const update = panel => {
      const track = panel.querySelector('.ts-brand-world__products');
      panel.querySelector('[data-world-prev]').disabled = track.scrollLeft <= 2;
      panel.querySelector('[data-world-next]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const nav = this.querySelector('.ts-discovery__brands');
    const updateNav = () => {
      if (!nav) return;
      this.querySelector('[data-brands-prev]').disabled = nav.scrollLeft <= 2;
      this.querySelector('[data-brands-next]').disabled = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2;
    };
    if (nav) {
      nav.addEventListener('scroll',updateNav,{passive:true,signal});
      this.querySelector('[data-brands-prev]').addEventListener('click',()=>nav.scrollBy({left:-nav.clientWidth*.8,behavior:motion()}),{signal});
      this.querySelector('[data-brands-next]').addEventListener('click',()=>nav.scrollBy({left:nav.clientWidth*.8,behavior:motion()}),{signal});
    }
    const activateImages = panel => {
      panel.querySelectorAll('img[data-src]').forEach(image => { image.loading='eager'; image.src=image.dataset.src; delete image.dataset.src; });
    };
    const delay = milliseconds => new Promise((resolve,reject) => {
      const abort=()=>{clearTimeout(timer);reject(new DOMException('Aborted','AbortError'));};
      const timer=setTimeout(()=>{signal.removeEventListener('abort',abort);resolve();},milliseconds);
      if(signal.aborted)abort();else signal.addEventListener('abort',abort,{once:true});
    });
    const load = panel => {
      activateImages(panel);
      if(panel.dataset.loaded==='true') return Promise.resolve(true);
      const seed=panel.querySelector('template[data-brand-seed]');
      if(seed){
        const track=panel.querySelector('.ts-brand-world__products');
        track.append(seed.content.cloneNode(true));seed.remove();
        panel.dataset.loaded='true';panel.querySelector('.ts-brand-world__status').hidden=true;update(panel);
        return Promise.resolve(true);
      }
      if(this.loads.has(panel)) return this.loads.get(panel);
      const work=(async()=>{
        const status=panel.querySelector('.ts-brand-world__status');
        const track=panel.querySelector('.ts-brand-world__products');
        status.querySelector('[data-brand-loading]').hidden=false;
        status.querySelector('[data-brand-error]').hidden=true;
        track.setAttribute('aria-busy','true');
        try {
          const url=new URL(panel.dataset.productsUrl,location.origin);
          const preview=new URLSearchParams(location.search).get('preview_theme_id');
          if(preview)url.searchParams.set('preview_theme_id',preview);
          let response;
          for(let attempt=0;attempt<3;attempt++){
            response=await fetch(url,{signal,credentials:'same-origin'});
            if(![429,503].includes(response.status)||attempt===2)break;
            await delay(Math.min(10,Number(response.headers.get('Retry-After'))||(attempt+1)*2)*1000);
          }
          if(!response.ok)throw Error('Products unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const content=doc.querySelector('[data-brand-products]');
          if(!content||content.dataset.brandProducts!==panel.dataset.collection||!content.querySelector('.ts-brand-world__item'))throw Error('Invalid products');
          content.querySelectorAll('[id]').forEach(element=>{
            const old=element.id;const fresh=panel.id+'-'+old;
            content.querySelectorAll('[for],[aria-labelledby],[aria-describedby]').forEach(label=>{
              for(const attr of ['for','aria-labelledby','aria-describedby']){
                if(label.hasAttribute(attr))label.setAttribute(attr,label.getAttribute(attr).split(' ').map(value=>value===old?fresh:value).join(' '));
              }
            });
            element.id=fresh;
          });
          track.replaceChildren(...content.childNodes);
          panel.dataset.loaded='true';status.hidden=true;update(panel);
          return true;
        } catch(error){
          if(error.name!=='AbortError'){
            status.querySelector('[data-brand-loading]').hidden=true;
            status.querySelector('[data-brand-error]').hidden=false;
          }
          return false;
        } finally {track.removeAttribute('aria-busy');this.loads.delete(panel);}
      })();
      this.loads.set(panel,work);return work;
    };
    const prefetch = () => {
      if(this.panels.length<2||signal.aborted)return;
      const panel=this.panels[(this.current+1)%this.panels.length];
      load(panel).then(()=>warmImages(panel));
    };
    const warmImages = panel => {
      if(signal.aborted)return;
      panel.querySelectorAll('img').forEach(image=>{
        if(image.dataset.tsPrepared)return;
        image.dataset.tsPrepared='true';image.fetchPriority='low';image.loading='eager';
        image.decode?.().catch(()=>{});
      });
    };
    this.select=async(index,focus=false,automatic=false)=>{
      if(!this.panels[index])return;
      const request=++this.request;
      if(index===this.current){
        this.effects.forEach(animation=>animation.cancel());this.effects.clear();
        this.panels.forEach((panel,i)=>{panel.hidden=i!==index;panel.inert=i!==index;});
        state({index,restart:true,busy:false});return;
      }
      const next=this.panels[index];
      const previousIndex=this.current;
      this.effects.forEach(animation=>animation.cancel());this.effects.clear();
      const previous=this.panels[this.current];
      this.current=index;
      this.panels.forEach(panel=>{panel.hidden=panel!==previous&&panel!==next;panel.inert=panel!==next;panel.style.zIndex=panel===next?'2':'1';});
      next.hidden=false;
      this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
      // Selection paints immediately; cached cards hydrate synchronously and image decoding never blocks a tap.
      const loading=load(next);
      next.querySelector('.ts-brand-world__status').hidden=next.dataset.loaded==='true';
      const track=next.querySelector('.ts-brand-world__products');
      track.scrollTo({left:0,behavior:'instant'});this.rails.get(next).target=0;update(next);
      if(focus)this.tabs[index]?.focus({preventScroll:true});
      if(nav&&this.tabs[index]){
        const box=this.tabs[index].getBoundingClientRect(),parent=nav.getBoundingClientRect();
        if(box.left<parent.left||box.right>parent.right)nav.scrollBy({left:box.left-parent.left-(parent.width-box.width)/2,behavior:motion()});
      }
      state({index,busy:true});
      let transition=Promise.resolve();
      if(motion()==='smooth'){
        const animation=next.animate([{opacity:0},{opacity:1}],{duration:220,easing:'cubic-bezier(.22,.61,.36,1)'});
        this.effects.add(animation);transition=animation.finished.catch(()=>{}).finally(()=>this.effects.delete(animation));
      }
      const [loaded]=await Promise.all([loading,transition]);
      if(request!==this.request||signal.aborted)return;
      if(!loaded&&automatic){this.select(previousIndex);return;}
      next.querySelector('.ts-brand-world__status').hidden=loaded;
      this.panels.forEach((panel,i)=>{panel.hidden=i!==index;});
      state({index,busy:false});prefetch();
    };
    this.addEventListener('ts:story-next',()=>this.select((this.current+1)%this.panels.length,false,true),{signal});
    this.tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>this.select(index),{signal});
      const prepare=()=>load(this.panels[index]).then(()=>warmImages(this.panels[index]));
      tab.addEventListener('pointerenter',prepare,{signal,passive:true});
      tab.addEventListener('focus',prepare,{signal});
      tab.addEventListener('keydown',event=>{
        if(event.ctrlKey||event.metaKey||event.altKey)return;
        let next=index;
        if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;
        else if(event.key==='ArrowLeft')next=(index-1+this.tabs.length)%this.tabs.length;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=this.tabs.length-1;
        else return;
        event.preventDefault();this.select(next,true);
      },{signal});
    });
    this.resize=new ResizeObserver(()=>{updateNav();this.panels.forEach(panel=>{if(!panel.hidden)update(panel);});});
    this.panels.forEach(panel=>{
      panel.inert=panel.hidden;
      const track=panel.querySelector('.ts-brand-world__products');
      const rail={target:0,timer:null};this.rails.set(panel,rail);
      panel.querySelector('[data-brand-retry]').addEventListener('click',async()=>{
        const loaded=await load(panel);if(loaded){update(panel);state({index:this.current,restart:true,busy:false});}
      },{signal});
      const move=direction=>{
        const width=track.querySelector('.ts-brand-world__item')?.getBoundingClientRect().width||260;
        const gap=parseFloat(getComputedStyle(track).columnGap)||0;
        const step=(width+gap)*Math.max(1,Math.floor(track.clientWidth/(width+gap)));
        rail.target=Math.max(0,Math.min(track.scrollWidth-track.clientWidth,rail.target+direction*step));
        track.scrollTo({left:rail.target,behavior:motion()});
      };
      panel.querySelector('[data-world-prev]').addEventListener('click',()=>move(-1),{signal});
      panel.querySelector('[data-world-next]').addEventListener('click',()=>move(1),{signal});
      track.addEventListener('scroll',()=>{update(panel);clearTimeout(rail.timer);rail.timer=setTimeout(()=>{rail.target=track.scrollLeft;},150);},{signal,passive:true});
      track.addEventListener('scrollend',()=>{rail.target=track.scrollLeft;},{signal});
      track.addEventListener('pointerdown',()=>{rail.target=track.scrollLeft;},{signal,passive:true});
      track.addEventListener('keydown',event=>{
        if(event.target!==track||event.ctrlKey||event.metaKey||event.altKey||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();
        if(event.key==='Home'||event.key==='End'){rail.target=event.key==='Home'?0:track.scrollWidth-track.clientWidth;track.scrollTo({left:rail.target,behavior:motion()});}
        else move(event.key==='ArrowLeft'?-1:1);
      },{signal});
      this.resize.observe(track);if(!panel.hidden)update(panel);
    });
    if(nav)this.resize.observe(nav);
    this.near=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){prefetch();this.near.disconnect();}},{rootMargin:'300px'});
    this.near.observe(this);
    this.addEventListener('shopify:block:select',event=>{
      const index=this.panels.findIndex(panel=>panel.id.endsWith('-'+event.detail.blockId));if(index>=0)this.select(index);
    },{signal});
    state({index:0,busy:false});updateNav();
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.resize?.disconnect();this.near?.disconnect();this.effects?.forEach(animation=>animation.cancel());this.rails?.forEach(rail=>clearTimeout(rail.timer));}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-collection-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ts-collection-directory')) {
    customElements.define('ts-collection-directory', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ts-collections__track');
        this.controls = this.querySelector('.ts-collections__controls');
        this.buttons = [...this.querySelectorAll('[data-step]')];
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = max < 2;
          this.buttons[0].disabled = this.track.scrollLeft < 2;
          this.buttons[1].disabled = this.track.scrollLeft >= max - 2;
        };
        const move = direction => {
          const card = this.track.querySelector('.ts-collections__card');
          if (!card) return;
          const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
          this.track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.step)), { signal }));
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        this.resize = new ResizeObserver(update);
        this.resize.observe(this.track);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-editorial-campaigns"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ts-editorial-campaigns')) customElements.define('ts-editorial-campaigns', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.ts-editorial__track');
      this.slides = [...this.querySelectorAll('.ts-editorial__slide')];
      this.tabs = [...this.querySelectorAll('[data-campaign-index]')];
      this.current = 0;
      this.target = 0;
      this.sequence = 0;
      this.preparedImages = new WeakSet();
      this.warmSlide = index => {
        const slide = this.slides[(index + this.slides.length) % this.slides.length];
        slide?.querySelectorAll('img').forEach(image => {
          if (this.preparedImages.has(image)) return;
          this.preparedImages.add(image);
          if (image.fetchPriority !== 'high') image.fetchPriority = 'low';
          image.loading = 'eager';
          image.decode?.().catch(()=>{});
        });
      };
      this.render = (index, busy = false) => {
        this.current = index;
        this.slides.forEach((slide, i) => { slide.inert = i !== index; slide.classList.toggle('is-active', i === index); });
        this.tabs.forEach(tab => { if (Number(tab.dataset.campaignIndex) === index) tab.setAttribute('aria-current','true'); else tab.removeAttribute('aria-current'); });
        if (this.preloadStarted) this.warmSlide(index + 1);
        this.dispatchEvent(new CustomEvent('ts:story-state',{detail:{index,busy}}));
      };
      const settle = () => {
        if (!this.track.clientWidth || this.fading) return;
        clearTimeout(this.scrollTimer);
        const index = Math.max(0,Math.min(this.slides.length - 1,Math.round(this.track.scrollLeft / this.track.clientWidth)));
        this.target = index;
        this.render(index);
      };
      this.go = async index => {
        const target = (index + this.slides.length) % this.slides.length;
        const sequence = ++this.sequence;
        this.target = target;
        this.warmSlide(target);
        this.fade?.cancel();
        this.fading = false;
        if(target===this.current){
          this.track.scrollTo({left:target*this.track.clientWidth,behavior:'instant'});
          this.render(target);
          this.dispatchEvent(new CustomEvent('ts:story-state',{detail:{index:target,busy:false,restart:true}}));
          return;
        }
        this.dispatchEvent(new CustomEvent('ts:story-state',{detail:{busy:true}}));
        const reduced = matchMedia('(prefers-reduced-motion:reduce)').matches;
        if (!reduced && Math.abs(target - this.current) > 1) {
          this.fading = true;
          this.fade = this.track.animate([{opacity:1},{opacity:0}],{duration:160,fill:'forwards',easing:'ease-out'});
          await this.fade.finished.catch(()=>{});
          if (sequence !== this.sequence || signal.aborted) return;
          this.track.scrollTo({left:target*this.track.clientWidth,behavior:'instant'});
          this.render(target,true);
          this.fade.cancel();
          this.fade = this.track.animate([{opacity:0},{opacity:1}],{duration:360,easing:'ease-out'});
          await this.fade.finished.catch(()=>{});
          if (sequence !== this.sequence || signal.aborted) return;
          this.fading = false;
          settle();
        } else {
          this.track.scrollTo({left:target*this.track.clientWidth,behavior:reduced?'instant':'smooth'});
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(settle,700);
        }
      };
      this.addEventListener('ts:story-next',()=>this.go(this.current+1),{signal});
      const warmIntent = event => {
        const tab = event.target.closest('[data-campaign-index]');
        if (tab) this.warmSlide(Number(tab.dataset.campaignIndex));
        else if (event.target.closest('[data-campaign-next]')) this.warmSlide(this.target + 1);
        else if (event.target.closest('[data-campaign-previous]')) this.warmSlide(this.target - 1);
      };
      this.addEventListener('pointerover',warmIntent,{signal,passive:true});
      this.addEventListener('focusin',warmIntent,{signal});
      this.addEventListener('click',event=>{
        const tab=event.target.closest('[data-campaign-index]');
        if(tab) this.go(Number(tab.dataset.campaignIndex));
        else if(event.target.closest('[data-campaign-previous]')) this.go(this.target-1);
        else if(event.target.closest('[data-campaign-next]')) this.go(this.target+1);
      },{signal});
      this.track.addEventListener('scroll',()=>{
        this.dispatchEvent(new CustomEvent('ts:story-state',{detail:{busy:true}}));
        clearTimeout(this.scrollTimer);this.scrollTimer=setTimeout(settle,160);
      },{signal,passive:true});
      this.track.addEventListener('scrollend',settle,{signal});
      this.track.addEventListener('pointerdown',()=>{this.target=this.current;},{signal,passive:true});
      this.track.addEventListener('keydown',event=>{
        if(event.target!==this.track || event.ctrlKey || event.metaKey || event.altKey || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();this.go(this.target+(event.key==='ArrowRight'?1:-1));
      },{signal});
      this.resize=new ResizeObserver(()=>{this.track.scrollTo({left:this.current*this.track.clientWidth,behavior:'instant'});settle();});
      this.resize.observe(this.track);
      this.addEventListener('shopify:block:select',event=>{
        const index=this.slides.findIndex(slide=>slide.id==='Campaign-'+event.detail.blockId);if(index>=0)this.go(index);
      },{signal});
      this.render(0);
      const prepareSlides = () => {
        if (signal.aborted || this.preloadStarted) return;
        this.preloadStarted = true;
        clearTimeout(this.preloadTimer);
        for (let offset = 1; offset < this.slides.length; offset++) this.warmSlide(this.current + offset);
      };
      const firstImage = this.slides[0]?.querySelector('.ts-editorial__media > img');
      if (firstImage?.complete) prepareSlides();
      else {
        firstImage?.addEventListener('load',prepareSlides,{signal,once:true});
        firstImage?.addEventListener('error',prepareSlides,{signal,once:true});
        this.preloadTimer = setTimeout(prepareSlides,1500);
      }
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.resize?.disconnect();this.fade?.cancel();clearTimeout(this.scrollTimer);clearTimeout(this.preloadTimer);this.preloadStarted=false;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-home-shelf"] && !Shopify.designMode) return;
  try {
    
  function initTimeShopShelves(root) {
    root.querySelectorAll('[data-tsh-shelf]').forEach((shelf) => {
      if (shelf.dataset.ready) return;
      shelf.dataset.ready = 'true';
      const track = shelf.querySelector('[data-tsh-track]');
      const previous = shelf.querySelector('[data-tsh-prev]');
      const next = shelf.querySelector('[data-tsh-next]');
      const update = () => {
        previous.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      };
      const move = (direction) => track.scrollBy({left: direction * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  initTimeShopShelves(document);
  document.addEventListener('shopify:section:load', (event) => initTimeShopShelves(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-product-brand"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ts-product-brand')) customElements.define('ts-product-brand', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    const track = this.querySelector('.ts-product-brand__products');
    if (!track) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
    let target = track.scrollLeft, timer;
    const update = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= track.scrollWidth-track.clientWidth-2; };
    const move = direction => {
      const width=track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
      target=Math.max(0,Math.min(track.scrollWidth-track.clientWidth,target+direction*width*Math.max(1,Math.floor(track.clientWidth/width))));
      track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    };
    prev.addEventListener('click',()=>move(-1),{signal}); next.addEventListener('click',()=>move(1),{signal});
    track.addEventListener('scroll',()=>{update();clearTimeout(timer);timer=setTimeout(()=>{target=track.scrollLeft;},160);},{signal,passive:true});
    track.addEventListener('pointerdown',()=>{target=track.scrollLeft;},{signal,passive:true});
    track.addEventListener('keydown',event=>{if(event.target!==track||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();move(event.key==='ArrowLeft'?-1:1);},{signal});
    this.resize=new ResizeObserver(update);this.resize.observe(track);update();
    signal.addEventListener('abort',()=>clearTimeout(timer),{once:true});
  }
  disconnectedCallback() { this.controller?.abort();this.controller=null;this.resize?.disconnect(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-watch-trends"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ts-watch-trends'))customElements.define('ts-watch-trends',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
  this.addEventListener('click',event=>{
   const link=event.target.closest('[data-trend-open]');
   if(link&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey){
    const dialog=document.getElementById(link.dataset.trendOpen);if(!dialog?.showModal)return;
    event.preventDefault();this.opener=link;this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();this.openDialog=dialog;
    if(!matchMedia('(prefers-reduced-motion:reduce)').matches)dialog.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:260,easing:'ease-out'});
   }
   if(event.target.closest('[data-trend-close]'))this.openDialog?.close();
  },{signal});
  this.querySelectorAll('dialog').forEach(dialog=>{
   dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}},{signal});
   dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||'';this.openDialog=null;this.opener?.focus({preventScroll:true});},{signal});
  });
 }
 disconnectedCallback(){this.openDialog?.close();if(this.openDialog)document.documentElement.style.overflow=this.previousOverflow||'';this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();
})();
